/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DeliverablePaymentStatus = {
    AwaitingDeliverableValidation: 'AWAITING_DELIVERABLE_VALIDATION',
    AwaitingClientPayment: 'AWAITING_CLIENT_PAYMENT',
    AwaitingFreelancerCompliance: 'AWAITING_FREELANCER_COMPLIANCE',
    FinancingAskedPayment: 'FINANCING_ASKED_PAYMENT',
    FinancingBlockedPayment: 'FINANCING_BLOCKED_PAYMENT',
    FinancingAcceptedPayment: 'FINANCING_ACCEPTED_PAYMENT',
    FinancingRefusedPayment: 'FINANCING_REFUSED_PAYMENT',
    OverduePayment: 'OVERDUE_PAYMENT',
    CompletedPayment: 'COMPLETED_PAYMENT'
} as const;
export type DeliverablePaymentStatus = typeof DeliverablePaymentStatus[keyof typeof DeliverablePaymentStatus];


export function instanceOfDeliverablePaymentStatus(value: any): boolean {
    for (const key in DeliverablePaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(DeliverablePaymentStatus, key)) {
            // @ts-ignore
            if (DeliverablePaymentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DeliverablePaymentStatusFromJSON(json: any): DeliverablePaymentStatus {
    return DeliverablePaymentStatusFromJSONTyped(json, false);
}

export function DeliverablePaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverablePaymentStatus {
    return json as DeliverablePaymentStatus;
}

export function DeliverablePaymentStatusToJSON(value?: DeliverablePaymentStatus | null): any {
    return value as any;
}

